"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearRingss = linearRingss;

var _extent = require("../../extent.js");

/**
 * @module ol/geom/flat/center
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {Array<number>} Flat centers.
 */
function linearRingss(flatCoordinates, offset, endss, stride) {
  var flatCenters = [];
  var extent = (0, _extent.createEmpty)();

  for (var i = 0, ii = endss.length; i < ii; ++i) {
    var ends = endss[i];
    extent = (0, _extent.createOrUpdateFromFlatCoordinates)(flatCoordinates, offset, ends[0], stride);
    flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
    offset = ends[ends.length - 1];
  }

  return flatCenters;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUhBOzs7O0FBS0E7Ozs7Ozs7QUFPTSxTQUFVQSxZQUFWLENBQXVCQyxlQUF2QixFQUF3Q0MsTUFBeEMsRUFBZ0RDLEtBQWhELEVBQXVEQyxNQUF2RCxFQUE2RDtFQUNqRSxJQUFNQyxXQUFXLEdBQUcsRUFBcEI7RUFDQSxJQUFJQyxNQUFNLEdBQUcsMEJBQWI7O0VBQ0EsS0FBSyxJQUFJQyxDQUFDLEdBQUcsQ0FBUixFQUFXQyxFQUFFLEdBQUdMLEtBQUssQ0FBQ00sTUFBM0IsRUFBbUNGLENBQUMsR0FBR0MsRUFBdkMsRUFBMkMsRUFBRUQsQ0FBN0MsRUFBZ0Q7SUFDOUMsSUFBTUcsSUFBSSxHQUFHUCxLQUFLLENBQUNJLENBQUQsQ0FBbEI7SUFDQUQsTUFBTSxHQUFHLCtDQUNQTCxlQURPLEVBRVBDLE1BRk8sRUFHUFEsSUFBSSxDQUFDLENBQUQsQ0FIRyxFQUlQTixNQUpPLENBQVQ7SUFNQUMsV0FBVyxDQUFDTSxJQUFaLENBQWlCLENBQUNMLE1BQU0sQ0FBQyxDQUFELENBQU4sR0FBWUEsTUFBTSxDQUFDLENBQUQsQ0FBbkIsSUFBMEIsQ0FBM0MsRUFBOEMsQ0FBQ0EsTUFBTSxDQUFDLENBQUQsQ0FBTixHQUFZQSxNQUFNLENBQUMsQ0FBRCxDQUFuQixJQUEwQixDQUF4RTtJQUNBSixNQUFNLEdBQUdRLElBQUksQ0FBQ0EsSUFBSSxDQUFDRCxNQUFMLEdBQWMsQ0FBZixDQUFiO0VBQ0Q7O0VBQ0QsT0FBT0osV0FBUDtBQUNEIiwibmFtZXMiOlsibGluZWFyUmluZ3NzIiwiZmxhdENvb3JkaW5hdGVzIiwib2Zmc2V0IiwiZW5kc3MiLCJzdHJpZGUiLCJmbGF0Q2VudGVycyIsImV4dGVudCIsImkiLCJpaSIsImxlbmd0aCIsImVuZHMiLCJwdXNoIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tL2ZsYXQvY2VudGVyLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19